<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<mat-expansion-panel id="goodsValueCustoms" *ngIf="!isQuote.value && ( shipment.shipmentForm$ | async ).get( 'customs' ) as customs" class="bordered" [class.invalid]="(shipment.highlightInvalid$ | async) && customs.invalid">

   <mat-expansion-panel-header>
      <mat-panel-title id="goodsValueCustomsPanelTitle">
         Goods Value for Customs Purposes
      </mat-panel-title>
   </mat-expansion-panel-header>

   <div [formGroup]="customs" class="customs">
      <div class="amount">
         <mat-form-field>
            <mat-label>Amount</mat-label>
            <input id="customsAmountInput" matInput type="number" step="0.01" min="0" placeholder="Amount" formControlName="value" [required]="customs.get('value').value || customs.get('currency').value">
            <mat-error id="customsAmountError" libInputErrors [control]="customs.get('value')"></mat-error>
         </mat-form-field>
      </div>

      <div class="currency">
         <lib-currency-selector id="customsCurrencySelector" formControlName="currency" [required]="customs.get('value').value || customs.get('currency').value"></lib-currency-selector>
      </div>
   </div>
</mat-expansion-panel>
